//components
import { BasicTooltip, IconLibrary, LoadingSpinner, ThriveIcon } from "thrive-components"
//hooks
import UseDownloadCSVButton from "./DownloadReportButton.hooks";

const DownloadReportButton = () => {
    const {buttonText, buttonAriaLabel, tooltipText, isDisabled, buttonClassName, onButtonClick, isDownloadingCSV} = UseDownloadCSVButton();
    
    return (
        <BasicTooltip 
            className={`below download-csv-tooltip ${buttonClassName}`}
            children={ 
                <button 
                    id="download-csv-button"
                    className={`download-csv-button`}
                    aria-label={buttonAriaLabel}
                    disabled={isDisabled}
                    onClick={onButtonClick}
                >
                    {buttonText}
                    {isDownloadingCSV
                        ?   <LoadingSpinner size={6} />
                        :   <ThriveIcon iconName={IconLibrary.DOWNLOAD} sizeInPx="10" color="var(--thriveSky)"/>
                    }
                </button>
            } 
            text={tooltipText}>
        </BasicTooltip>
    )
}
export default DownloadReportButton